// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { Menu, X } from "lucide-react";

// export default function Navbar() {
//   const location = useLocation();
//   const [menuOpen, setMenuOpen] = useState(false);

//   const navItems = [
//     { name: "HOME", path: "/" },
//     { name: "ABOUT", path: "/about" },
//     { name: "OUR PILLARS", path: "/our-pillars" },
//     { name: "OUR SOLUTIONS", path: "/our-solutions" },
//     { name: "OUR REACH", path: "/our-reach" },
//     { name: "INVESTORS", path: "/investor" },
//     { name: "OUR TEAM", path: "/team" },
//     { name: "OUR PARTNERS", path: "/partners" },
//     { name: "NEWS & EVENTS", path: "/news" },
//   ];

//   const isActive = (path) =>
//     location.pathname === path ||
//     (path !== "/" && location.pathname.startsWith(path));

//   return (
//     <header className="bg-white/90 backdrop-blur-md border-b border-purple-100">
//       <nav className="w-full px-4 sm:px-6 py-3 sm:py-4">
//         <div className="relative flex items-center">
//           {/* 左：Logo（始终可见） */}
//           <Link to="/" className="flex items-center gap-2 sm:gap-3">
//             <img
//               src="/ainova_logo_white.png"
//               alt="AI Nova Logo"
//               className="h-7 sm:h-8 xl:h-9"
//             />
//           </Link>

//           {/* 中：导航，绝对居中，>= xl 显示 */}
//           <ul
//             className="
//               hidden xl:flex
//               absolute left-1/2
//               -translate-x-[55%] 2xl:-translate-x-1/2
//               items-center gap-2 xl:gap-3
//               text-[0.7rem] xl:text-[0.78rem]
//               font-semibold text-[#2a0f4c]
//             "
//           >
//             {navItems.map((item) => (
//               <li
//                 key={item.name}
//                 className={`cursor-pointer flex items-center gap-1 px-2 py-1 rounded-lg transition-all duration-200 ${
//                   isActive(item.path)
//                     ? "bg-[rgba(138,79,255,0.08)] text-[#6a2dd9]"
//                     : "hover:bg-[rgba(138,79,255,0.08)] hover:text-[#6a2dd9]"
//                 }`}
//               >
//                 <Link to={item.path} className="whitespace-nowrap">
//                   {item.name}
//                 </Link>
//               </li>
//             ))}
//           </ul>

//           {/* 右：按钮区（>= xl 显示） */}
//           <div className="hidden xl:flex items-center gap-2 ml-auto">
//             <Link
//               to="/login"
//               className="text-xs xl:text-sm px-3 py-1.5 border border-[#8a4fff] font-semibold text-[#2a0f4c] rounded-lg bg-white/70 hover:bg-[rgba(138,79,255,0.1)] backdrop-blur-sm transition-all duration-200 whitespace-nowrap"
//             >
//               Log in
//             </Link>

//             <Link
//               to="/signup"
//               className="text-xs xl:text-sm px-3 py-1.5 text-white font-semibold rounded-lg bg-gradient-to-r from-[#8a4fff] to-[#6a2dd9] shadow-[0_4px_14px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 whitespace-nowrap"
//             >
//               Sign up
//             </Link>

//             <Link
//               to="/contact"
//               className="text-xs xl:text-sm px-3 py-1.5 text-white font-semibold rounded-lg bg-gradient-to-r from-[#b38aff] to-[#7b5aff] shadow-[0_4px_14px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 whitespace-nowrap"
//             >
//               Contact Us
//             </Link>
//           </div>

//           {/* 汉堡按钮：< xl 显示，在最右边 */}
//           <button
//             className="xl:hidden ml-auto p-2 text-[#6a2dd9]"
//             onClick={() => setMenuOpen(!menuOpen)}
//           >
//             {menuOpen ? <X size={26} /> : <Menu size={26} />}
//           </button>
//         </div>
//       </nav>

//       {/* 移动端 / 平板 / 小桌面菜单（< xl） */}
//       <AnimatePresence>
//         {menuOpen && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             transition={{ duration: 0.3 }}
//             className="xl:hidden w-full bg-white/95 backdrop-blur-md border-t border-white/30 shadow-lg"
//           >
//             <div className="max-w-7xl mx-auto">
//               <ul className="flex flex-col items-start p-4 gap-3 text-[0.9rem] font-semibold text-[#2a0f4c]">
//                 {navItems.map((item) => (
//                   <li
//                     key={item.name}
//                     className={`w-full rounded-lg transition-all duration-200 ${
//                       isActive(item.path)
//                         ? "bg-[rgba(138,79,255,0.08)] text-[#6a2dd9]"
//                         : "hover:bg-[rgba(138,79,255,0.08)] hover:text-[#6a2dd9]"
//                     }`}
//                   >
//                     <Link
//                       to={item.path}
//                       onClick={() => setMenuOpen(false)}
//                       className="block w-full px-3 py-2 rounded-lg"
//                     >
//                       {item.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>

//               <div className="flex flex-col gap-2 p-4 border-t border-white/30 items-start">
//                 <Link
//                   to="/login"
//                   onClick={() => setMenuOpen(false)}
//                   className="inline-flex px-5 py-2 border border-[#8a4fff] text-[#2a0f4c] font-semibold rounded-lg bg-white/70 hover:bg-[rgba(138,79,255,0.1)] backdrop-blur-sm transition-all duration-200 justify-center"
//                 >
//                   Log in
//                 </Link>

//                 <Link
//                   to="/signup"
//                   onClick={() => setMenuOpen(false)}
//                   className="inline-flex px-5 py-2 text-white font-semibold rounded-lg bg-gradient-to-r from-[#8a4fff] to-[#6a2dd9] shadow-[0_6px_18px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 justify-center"
//                 >
//                   Sign up
//                 </Link>

//                 <Link
//                   to="/contact"
//                   onClick={() => setMenuOpen(false)}
//                   className="inline-flex px-5 py-2 text-white font-semibold rounded-lg bg-gradient-to-r from-[#b38aff] to-[#7b5aff] shadow-[0_6px_18px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 justify-center"
//                 >
//                   Contact Sales
//                 </Link>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </header>
//   );
// }
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { name: "HOME", path: "/" },
    { name: "ABOUT", path: "/about" },
    { name: "OUR PILLARS", path: "/our-pillars" },
    { name: "OUR SOLUTIONS", path: "/our-solutions" },
    { name: "OUR REACH", path: "/our-reach" },
    { name: "INVESTORS", path: "/investor" },
    { name: "OUR TEAM", path: "/team" },
    { name: "OUR PARTNERS", path: "/partners" },
    { name: "NEWS & EVENTS", path: "/news" },
  ];

  const isActive = (path) =>
    location.pathname === path ||
    (path !== "/" && location.pathname.startsWith(path));

  return (
    <header className="bg-white/90 backdrop-blur-md border-b border-purple-100">
      <nav className="w-full px-4 sm:px-6 py-3 sm:py-4">
        <div className="relative flex items-center">
          {/* 左：Logo（始终可见） */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <img
              src="/ainova_logo_white.png"
              alt="AI Nova Logo"
              className="h-7 sm:h-8 xl:h-9"
            />
          </Link>

          {/* 中：导航，绝对居中，>= xl 显示 */}
          <ul
            className="
              hidden xl:flex
              absolute left-1/2
              -translate-x-[60%] 2xl:-translate-x-1/2
              items-center gap-2 xl:gap-3
              text-[0.7rem] xl:text-[0.78rem]
              font-semibold text-[#2a0f4c]
            "
          >
            {navItems.map((item) => (
              <li
                key={item.name}
                className={`cursor-pointer flex items-center gap-1 px-2 py-1 rounded-lg transition-all duration-200 ${
                  isActive(item.path)
                    ? "bg-[rgba(138,79,255,0.08)] text-[#6a2dd9]"
                    : "hover:bg-[rgba(138,79,255,0.08)] hover:text-[#6a2dd9]"
                }`}
              >
                <Link to={item.path} className="whitespace-nowrap">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* 右：按钮区（>= xl 显示） */}
          <div className="hidden xl:flex items-center gap-2 ml-auto">
            {/* <Link
              to="/login"
              className="text-xs xl:text-sm px-3 py-1.5 border border-[#8a4fff] font-semibold text-[#2a0f4c] rounded-lg bg-white/70 hover:bg-[rgba(138,79,255,0.1)] backdrop-blur-sm transition-all duration-200 whitespace-nowrap"
            >
              Log in
            </Link>

            <Link
              to="/signup"
              className="text-xs xl:text-sm px-3 py-1.5 text-white font-semibold rounded-lg bg-gradient-to-r from-[#8a4fff] to-[#6a2dd9] shadow-[0_4px_14px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 whitespace-nowrap"
            >
              Sign up
            </Link> */}

            <Link
              to="/contact"
              className="text-xs xl:text-sm px-3 py-1.5 text-white font-semibold rounded-lg bg-gradient-to-r from-[#b38aff] to-[#7b5aff] shadow-[0_4px_14px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 whitespace-nowrap"
            >
              Contact Us
            </Link>
          </div>

          {/* 汉堡按钮：< xl 显示，在最右边 */}
          <button
            className="xl:hidden ml-auto p-2 text-[#6a2dd9]"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </nav>

      {/* 移动端 / 平板 / 小桌面菜单（< xl） */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="xl:hidden w-full bg-white/95 backdrop-blur-md border-t border-white/30 shadow-lg"
          >
            <div className="max-w-7xl mx-auto">
              <ul className="flex flex-col items-start p-4 gap-3 text-[0.9rem] font-semibold text-[#2a0f4c]">
                {navItems.map((item) => (
                  <li
                    key={item.name}
                    className={`w-full rounded-lg transition-all duration-200 ${
                      isActive(item.path)
                        ? "bg-[rgba(138,79,255,0.08)] text-[#6a2dd9]"
                        : "hover:bg-[rgba(138,79,255,0.08)] hover:text-[#6a2dd9]"
                    }`}
                  >
                    <Link
                      to={item.path}
                      onClick={() => setMenuOpen(false)}
                      className="block w-full px-3 py-2 rounded-lg"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>

              <div className="flex flex-col gap-2 p-4 border-t border-white/30 items-start">
                <Link
                  to="/login"
                  onClick={() => setMenuOpen(false)}
                  className="inline-flex px-5 py-2 border border-[#8a4fff] text-[#2a0f4c] font-semibold rounded-lg bg-white/70 hover:bg-[rgba(138,79,255,0.1)] backdrop-blur-sm transition-all duration-200 justify-center"
                >
                  Log in
                </Link>

                <Link
                  to="/signup"
                  onClick={() => setMenuOpen(false)}
                  className="inline-flex px-5 py-2 text-white font-semibold rounded-lg bg-gradient-to-r from-[#8a4fff] to-[#6a2dd9] shadow-[0_6px_18px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 justify-center"
                >
                  Sign up
                </Link>

                <Link
                  to="/contact"
                  onClick={() => setMenuOpen(false)}
                  className="inline-flex px-5 py-2 text-white font-semibold rounded-lg bg-gradient-to-r from-[#b38aff] to-[#7b5aff] shadow-[0_6px_18px_rgba(138,79,255,0.35)] hover:opacity-90 transition-all duration-200 justify-center"
                >
                  Contact Sales
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
